import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UserService } from "../../../app/service/user.service";
import { toast } from "react-toastify";
import { Footer } from "../../../components/footer";
import { NavBar } from "../../../components/nav-bar";
import SignInImage from "../../../assets/images/sign-in.png";

const ResetPassword = () => {
  const { token } = useParams(); // Get token from URL
  console.log("tokem",token)
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState<any>({});

  const handleInput = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors: any = {};

    if (!formData.newPassword) {
      newErrors.newPassword = "New Password is required";
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!validate()) return;

    if (!token) {
      toast.error("Invalid or missing token.");
      return;
    }

    let payload={
      password:formData.newPassword
    }

    try {
      const response = await UserService.resetPassword(
        token,
        payload
      );
      if (response.status === "Success") {
        toast.success(response.message);
        navigate("/sign-in");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("An error occurred while resetting the password.");
    }
  };

  return (
    <>
      <div className="container-fluid scroll-bar-width-none primary-bg text-white pt-5">
        <div className="row">
          <div className="col-md-12">
            <NavBar activeMenu={"home"} />
          </div>
          <div className="col-md-12 px-3 mx-md-0">
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-10 col-md-11 mx-auto pt-5">
                    <div className="fs-2 fw-bold my-3 text-start">
                      Reset
                      <span className="primary-color"> Password</span>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label htmlFor="newPassword" className="form-label">
                          New Password
                        </label>
                        <input
                          type="password"
                          id="newPassword"
                          className={`form-control custom-input bg-transparent border-0 border-bottom rounded-0 text-white ${
                            errors.newPassword ? "is-invalid" : ""
                          }`}
                          // placeholder="Enter New Password"
                          name="newPassword"
                          value={formData.newPassword}
                          onChange={handleInput}
                          required
                        />
                        {errors.newPassword && (
                          <div className="invalid-feedback">
                            {errors.newPassword}
                          </div>
                        )}
                      </div>

                      <div className="mb-3">
                        <label htmlFor="confirmPassword" className="form-label">
                          Confirm New Password
                        </label>
                        <input
                          type="password"
                          id="confirmPassword"
                          className={`form-control custom-input bg-transparent border-0 border-bottom rounded-0 text-white mt-2 ${
                            errors.confirmPassword ? "is-invalid" : ""
                          }`}
                          name="confirmPassword"
                          value={formData.confirmPassword}
                          onChange={handleInput}
                          required
                        />
                        {errors.confirmPassword && (
                          <div className="invalid-feedback">
                            {errors.confirmPassword}
                          </div>
                        )}
                      </div>

                      <div className="text-center">
                        <button
                          type="submit"
                          className="bg-white px-5 py-2 w-100 secondary-btn"
                        >
                          Reset Password
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-md-6 px-0 d-none d-md-block pt-4">
                <div className="d-flex justify-content-end">
                  <img src={SignInImage} className="w-100" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 border-top border-bottom border-light mt-3 pt-4 text-white">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
